<template>
    <BCard v-if="cash">
        <ValidationObserver ref="form" #default="{ invalid }">
            <BForm @submit.prevent="onSubmit">
                <BRow>
                    <TextInputValidated vsName="Name" :vsModel.sync="cash.name" vsLabel="name" vsMd="6" vsRequired vsRules="required" />
                    <VSelectValidated vsName="Group" v-if="groups && groups.length>1" :vsModel.sync="cash.group_id" :vsOptions="groups" :vsReduce="group=>group.id" vsMd="6" vsLabel="name" vsRequired vsRules="required" />
                </BRow>
                <BButton variant="primary" class="mt-3 mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
                <BButton variant="outline-secondary" class="mt-3" type="reset" :to="{ name:'cash' }" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{$t('Cancel')}} </BButton>
            </BForm>
        </ValidationObserver>
    </BCard>
</template>

<script>
import { BButton, BCard, BForm, BRow } from 'bootstrap-vue';
import { ValidationObserver } from 'vee-validate';
import { onUnmounted, ref } from '@vue/composition-api';
import TextInputValidated from '@/components/forms/TextInputValidated.vue';
import VSelectValidated from '@/components/forms/vSelectValidated.vue';
import cashModule from '../cashModule'
import popups from '@/hooks/popups';
import router from '@/router';
import store from '@/store';


export default {
    components: { BCard, ValidationObserver, BForm, BRow, TextInputValidated, VSelectValidated, BButton },
    setup(){
        const { errorToast } = popups()
        const CASH_MODULE = 'cashes'
        const groups = ref([])
        const cash = ref(null)

        if(!store.hasModule(CASH_MODULE)){
            store.registerModule(CASH_MODULE, cashModule)
        }

        onUnmounted(() => {
            if(store.hasModule(CASH_MODULE)) {
                store.unregisterModule(CASH_MODULE)
            }
        })

        const onSubmit = function(){
            this.$refs.form.validate().then(success => {
                if(success){
                    store.dispatch('cashes/updateCash', JSON.parse(JSON.stringify(cash.value)))
                        .then(response => { 
                                if (response.data.success) {
                                    this.$router.push({ name: 'cash' })
                                }
                            })
                        .catch(error => { errorToast('Can\'t add cash') })
                }
            })
        }

        store.dispatch('cashes/editCash', { id: router.currentRoute.params.id }).then(response => {
            cash.value = response.data.cash
            groups.value =  response.data.groups
        })

        return {
            onSubmit,
            groups,
            cash
        }
    }
}
</script>